import React from "react";
import Navbar from "../components/layout/Navbar";
import SolutionsSection from "../components/sections/home/SolutionsSection";

const SolutionsPage = () => (
  <div className="min-h-screen bg-paper">
    <Navbar />
    <main className="pt-16">
      <section className="py-20 md:py-28 bg-paper">
        <div className="max-w-7xl mx-auto px-6">
          <p className="text-xs font-semibold tracking-widest text-brand-600 uppercase mb-4">Solutions</p>
          <h1 className="font-display text-5xl md:text-6xl font-bold tracking-tight text-ink max-w-4xl leading-[1.05]">
            Mobility intelligence built around the decision.
          </h1>
          <p className="mt-6 text-lg md:text-xl text-ink-muted max-w-2xl leading-relaxed">
            Explore how observed movement can support planning, operations, investment, and evaluation. This page is an initial commercial draft.
          </p>
        </div>
      </section>
      <SolutionsSection />
    </main>
  </div>
);

export default SolutionsPage;
